
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { dateTimeFormatter, readCookie } from '@/tools/tools';
import { getStatusCouponList, getInstruction } from '@/services/http';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';

@Component({
  components: {
    Header,
    Footer,
    NavMenu
  }
})
export default class extends Vue {
  @Action('user/setUserInfoList') setUserInfoList!: Function

  @State('user') userInfo: any // 用户信息

  isLoading: boolean = false // 加载

  showInstructions: boolean = false // 显示使用说明

  activeIndex: number = 0 // 0未使用，1已使用，2已过期

  pageNo: number = 1 // 页数

  pageSize: number = 8 // 条数

  totalnumber: number = 0

  couponList: any[] = [] // 优惠券列表

  instruction: any = '' // 使用说明

  private async created() {
    await this.getStatusCouponList(0);
    await this.getInstruction();
  }

  handleCouponTab(index:number) {
    this.pageNo = 1;
    this.getStatusCouponList(index);
  }

  async getStatusCouponList(num: number) {
    const anchor = readCookie('anchor');
    this.couponList = [];
    this.activeIndex = num;
    this.totalnumber = 0;
    this.isLoading = true;
    try {
      const res: any = await getStatusCouponList({
        useStatus: this.activeIndex,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        companyId: 1,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : ''
      });
      if (res.data.code === 100) {
        this.totalnumber = res.data.data.total;
        this.couponList = this.normalizeCoupons(res.data.data.list || []);
      }
    } catch (e) {
      this.couponList = [];
    } finally {
      this.isLoading = false;
    }
  }

  private normalizeCoupons(list: any[]): any[] {
    return list.map((item: any) => ({
      ...item,
      useStartDate: dateTimeFormatter(item.useStartDate),
      useEndDate: dateTimeFormatter(item.useEndDate)
    }));
  }

  couponDateText(item: any): string {
    const startsAt = item.useStartDate ? new Date(item.useStartDate).getTime() : 0;
    return startsAt > Date.now()
      ? `${item.useStartDate} 开始可用`
      : `有效期至：${item.useEndDate}`;
  }

  showDesc() {
    this.showInstructions = true;
  }

  async getInstruction() {
    try {
      const res: any = await getInstruction();
      if (res.data.code === 100) {
        this.instruction = res.data.data;
      }
    } catch (e) {
      this.instruction = '优惠券仅限指定商品使用。未生效的优惠券将在开始时间后可用，已生效的优惠券请在有效期内使用。';
    }
  }

  handleCurrentChange(val: number) {
    this.pageNo = val;
    this.getStatusCouponList(this.activeIndex);
  }

  handleSizeChange(val: number) {
    this.pageSize = val;
    this.getStatusCouponList(this.activeIndex);
  }
}
